import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/guides/page.tsx");
